import { FC, Dispatch, SetStateAction, useCallback, useRef, useState, useEffect } from 'react'
import cn from 'classnames'
import ReactPaginate from 'react-paginate'
import { Params } from 'api/fetch'

import styles from './Pagination.module.scss'

interface PaginationProps {
  isSmallAndUp: boolean
  setQueryParams: Dispatch<SetStateAction<Params>>
  total: number
  limit: number
  page: number
  sticky?: boolean
}

const Pagination: FC<PaginationProps> = ({ setQueryParams, isSmallAndUp, total, limit, page, sticky = false }) => {
  const paginationRef = useRef<HTMLDivElement | null>(null)
  const [isSticky, setIsSticky] = useState(false)

  useEffect(() => {
    if (sticky === false) {
      return
    }

    if (!paginationRef.current) {
      return
    }

    const observer = new IntersectionObserver(([e]) => setIsSticky(e.intersectionRatio < 1), { threshold: [1] })

    observer.observe(paginationRef.current)
  }, [paginationRef, sticky])

  const handlePagination = useCallback(
    ({ selected }: any) => setQueryParams((prev: any) => ({ ...prev, page: selected + 1 })),
    [setQueryParams],
  )

  return (
    <div className={cn(styles.pagination, sticky && isSticky && styles.isSticky)} ref={paginationRef}>
      <ReactPaginate
        previousLabel={isSmallAndUp ? 'Previous' : 'Prev'}
        pageCount={Math.ceil(total / limit)}
        forcePage={page - 1}
        marginPagesDisplayed={isSmallAndUp ? 2 : 1}
        pageRangeDisplayed={isSmallAndUp ? 5 : 1}
        activeLinkClassName={styles.active}
        disabledClassName={styles.disabled}
        onPageChange={handlePagination}
      />
    </div>
  )
}

export default Pagination
